import { ADD_NEW_KITCHEN_ORDER, REMOVE_KITCHEN_ORDER, RESET_KITCHEN_ORDERS_STATE, SET_KITCHEN_CONFIG, SET_KITCHEN_MONITOR_CONFIG, SET_KITCHEN_MONITOR_CONFIG_IS_LOADING, SET_KITCHEN_MONITOR_CONFIG_IS_SKELETON, SET_KITCHEN_MONITOR_CONFIGS, SET_KITCHEN_MONITOR_CONFIGS_UPDATE, SET_KITCHEN_ORDERS, SET_KITCHEN_ORDERS_IS_LOADING, SET_KITCHEN_ORDERS_LOADING, SET_KITCHEN_ORDERS_TOTAL_LENGTH, SET_KITCHEN_SELECTED_ORDER, SET_SHOW_KITCHEN_MONITOR_SKELETON, UPDATE_KITCHEN_ORDER } from '../../actionTypes/kitchenMonitor'

export const resetKitchenOrdersState = () => ({ type: RESET_KITCHEN_ORDERS_STATE })

export const setKitchenOrders = value => ({ type: SET_KITCHEN_ORDERS, value })

export const addNewKitchenOrder = value => ({ type: ADD_NEW_KITCHEN_ORDER, value })

export const updateKitchenOrder = value => ({ type: UPDATE_KITCHEN_ORDER, value })

export const removeKitchenOrder = value => ({ type: REMOVE_KITCHEN_ORDER, value })

export const setKitchenOrdersTotalLength = value => ({ type: SET_KITCHEN_ORDERS_TOTAL_LENGTH, value })

export const setKitchenSelectedOrder = value => ({ type: SET_KITCHEN_SELECTED_ORDER, value })

export const setKitchenMonitorConfigs = value => ({ type: SET_KITCHEN_MONITOR_CONFIGS, value })

export const setKitchenMonitorConfig = value => ({ type: SET_KITCHEN_MONITOR_CONFIG, value })

export const setKitchenMonitorConfigIsLoading = value => ({ type: SET_KITCHEN_MONITOR_CONFIG_IS_LOADING, value })

export const setKitchenConfig = value => ({ type: SET_KITCHEN_CONFIG, value })

export const setKitchenOrdersLoading = value => ({ type: SET_KITCHEN_ORDERS_LOADING, value })

export const setKitchenMonitorConfigsUpdate = value => ({ type: SET_KITCHEN_MONITOR_CONFIGS_UPDATE, value })

export const setKitchenOrdersIsLoading = value => ({ type: SET_KITCHEN_ORDERS_IS_LOADING, value })

export const setKitchenMonitorConfigIsSkeleton = value => ({ type: SET_KITCHEN_MONITOR_CONFIG_IS_SKELETON, value })

export const setShowKitchenMonitorSkeleton = value => ({ type: SET_SHOW_KITCHEN_MONITOR_SKELETON, value })
